import { render, staticRenderFns } from "./LogsRequestByRelations.vue?vue&type=template&id=dede4eb0&"
import script from "./LogsRequestByRelations.vue?vue&type=script&lang=js&"
export * from "./LogsRequestByRelations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports